import {DateCustom} from "frontend-core";
import {ILogContextDto, LogContext} from "@/modules/Segmentation/models/LogContext";

export class Log {
    id: string;
    message: string;
    level: string;
    topic: string;
    createdAt: DateCustom;
    agentName: string;
    agentId: string;
    userLogin: string;
    context: LogContext;

    constructor(dto?: ILogDto)
    constructor(
        id?: string,
        message?: string,
        level?: string,
        topic?: string,
        createdAt?: DateCustom,
        agentName?: string,
        agentId?: string,
        userLogin?: string,
        context?: LogContext,
    )
    constructor(
        dtoOrId: ILogDto | string = "",
        message: string = "",
        level: string = "",
        topic: string = "",
        createdAt: DateCustom = DateCustom.dateNow,
        agentName: string = "",
        agentId: string = "",
        userLogin: string = "",
        context: LogContext = new LogContext(),
    ) {
        if (typeof dtoOrId !== "string") {
            this.id = String(dtoOrId.id);
            this.message = dtoOrId.message;
            this.level = dtoOrId.level;
            this.topic = dtoOrId.topic;
            this.createdAt = new DateCustom(dtoOrId.createdAt);
            this.agentId = dtoOrId.agentId;
            this.agentName = dtoOrId.agentName;
            this.userLogin = dtoOrId.userLogin;

            if (typeof dtoOrId.context === "string") {
                this.context = new LogContext(JSON.parse(dtoOrId.context) as ILogContextDto);
            } else {
                this.context = new LogContext(dtoOrId.context);
            }
        } else {
            this.id = dtoOrId;
            this.message = message;
            this.level = level;
            this.topic = topic;
            this.createdAt = createdAt;
            this.agentId = agentId;
            this.agentName = agentName;
            this.userLogin = userLogin;
            this.context = context;
        }
    }
}

export type ILogDto = Readonly<{
    id: number | string;
    message: string;
    level: string;
    topic: string;
    createdAt: string;
    agentName: string;
    agentId: string;
    userLogin: string;
    context: string | ILogContextDto;
}>;
